var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFootLogo1S4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_826_113)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_826_113",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.681,
    cy: 31.681,
    r: 31.681,
    fill: "#F578A5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_826_113)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.681,
    cy: 31.681,
    r: 31.681,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1082 62.9028V63.5959H17.8013H47.1865H47.8796V62.9028V50.5728C47.8796 49.4403 46.982 48.5116 45.8501 48.473L19.2809 47.5672C18.0931 47.5267 17.1082 48.4786 17.1082 49.6671V62.9028Z",
    fill: "#272727",
    stroke: "#272727",
    strokeWidth: 1.38604
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_826_113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2124 22.246C29.6688 13.269 26.8916 5.96203 26.8994 5.95336C26.7625 5.58743 26.9482 5.17989 27.3141 5.043C27.4987 4.97395 27.7037 4.98508 27.8798 5.07362C39.5324 10.6495 44.5468 17.8475 45.507 24.3552C45.8887 26.8836 45.6501 29.4669 44.8117 31.8827C44.0434 34.1117 42.7637 36.1298 41.0751 37.7752C37.8269 40.9121 33.2876 42.3582 28.8075 40.8922C27.6615 40.5183 26.5801 39.9698 25.6015 39.2659C23.6383 37.857 22.1492 35.8852 21.3312 33.6114C20.4632 31.1795 20.4356 28.527 21.2528 26.0777C21.7042 24.7068 22.3652 23.4142 23.2124 22.246Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0411 6.18507C26.7573 5.91662 26.7448 5.4689 27.0133 5.18513C27.2817 4.90137 27.7294 4.88884 28.0132 5.15729C28.0341 5.17704 28.0537 5.19803 28.072 5.22019C28.098 5.24359 33.724 11.1408 34.5278 22.5389L34.5361 22.6458C34.7097 25.3098 34.6239 27.9844 34.2804 30.6318L38.1273 27.6837C38.4496 27.4627 38.8899 27.5449 39.1108 27.867C39.3107 28.1587 39.2646 28.5532 39.0027 28.7909L33.9752 32.632C32.8496 39.2491 28.8819 48.6103 34.1344 54.4693C34.3874 54.767 34.3511 55.2134 34.0534 55.4664C33.77 55.7072 33.3486 55.6875 33.089 55.4212C26.7904 48.4007 31.3736 39.7035 32.6279 32.1825L32.6444 32.0771C33.1544 29.0841 33.3292 26.0437 33.1655 23.0121L28.6437 19.6989C28.3212 19.4785 28.2384 19.0383 28.4589 18.7158C28.6794 18.3932 29.1195 18.3105 29.4421 18.531C29.4554 18.5401 29.4685 18.5497 29.4812 18.5597L32.9848 21.1392C31.8919 11.2588 27.0616 6.20876 27.0411 6.18507Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_826_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.362,
    height: 63.362,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_826_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.8832,
    height: 38.8832,
    fill: "white",
    transform: "translate(3.73486 31.0383) rotate(-48)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootLogo1S4);
export default __webpack_public_path__ + "static/media/footLogo1s4.b5dbb37f579633d8026401c9dd69a86f.svg";
export { ForwardRef as ReactComponent };